<template>
  <v-row dense align="center" class="count-input-row">
    <v-col cols="6">
      <span class="count-label">{{ countItem.name }}</span>
    </v-col>
    <v-col cols="6">
      <v-text-field
        type="number"
        :min="countItem.min_value"
        :max="countItem.max_value"
        :step="countItem.allow_decimals ? 0.5 : 1"
        :rules="validationRules"
        :value="value"
        @input="$emit('input', $event !== '' ? Number($event) : null)"
        dense
        outlined
        hide-details="auto"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CountInput',
  props: {
    countItem: {
      type: Object,
      required: true
    },
    value: {
      default: null
    }
  },
  computed: {
    validationRules() {
      const rules = []

      if (!this.countItem.allow_decimals) {
        rules.push(v => v === null || v === '' || Number(v) % 1 === 0 || 'Must be a whole number')
      }
      if (this.countItem.min_value !== null && this.countItem.min_value !== undefined) {
        rules.push(v => v === null || v === '' || Number(v) >= this.countItem.min_value || `Min: ${this.countItem.min_value}`)
      }
      if (this.countItem.max_value !== null && this.countItem.max_value !== undefined) {
        rules.push(v => v === null || v === '' || Number(v) <= this.countItem.max_value || `Max: ${this.countItem.max_value}`)
      }

      return rules
    }
  }
}
</script>

<style scoped>
.count-input-row {
  margin-bottom: 4px;
}
.count-label {
  font-size: 14px;
}
</style>
